import React from 'react';
import Table from '../Table';

const InvoicesTableSkeleton: React.FC = () => {
  const columns = React.useMemo(
    () => [
      {
        Header: 'Date',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-15 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
      {
        Header: 'Description',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-60 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
      {
        Header: 'Amount',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-14 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
      {
        Header: 'Invoice',
        disableSortBy: true,
        accessor: () => (
          <span className="block w-20 h-3  bg-gray-200 rounded animate-pulse" />
        ),
      },
    ],
    []
  );

  const data = new Array(3).fill('');

  return <Table columns={columns} data={data} />;
};

export default InvoicesTableSkeleton;
